type NormalizeRequiredInputOptions = {
  required?: boolean
  type?: string
  trim?: boolean
}

export const normalizeRequiredInputValue = (value: any, options: NormalizeRequiredInputOptions = {}) => {
  if (!options.required || options.type === 'password' || typeof value !== 'string') return value

  const trimmedValue = value.trim()
  return options.trim || trimmedValue === '' ? trimmedValue : value
}
